import React, {useEffect, useState} from "react";
import logoIcon from "../../../../images/logos/logoSmall.png";
import CustomFilePlayer from "../customFilePlayer/customFilePlayer";
import {TorresstreamApi} from "../../../../apis/torrestream-api/torresstream-api";

const VeronlineStreamPlayer = ({type, tmdbId, season, episode, imagePath, item, onGoNextEpisode, squadFlixTvHook}) => {

    const [links, setLinks] = useState([]);
    const [selectedLink, setSelectedLink] = useState(null);
    const [linksLoading, setLinksLoading] = useState(true);

    useEffect(() => {
        setLinksLoading(true);

        const processFetch = async () => {
            if (type === "movie") {
                return await TorresstreamApi.fetchOnlineMovie(tmdbId);
            }
            return await TorresstreamApi.fetchOnlineSerieEpisode(tmdbId, season, episode);
        }

        const compareLanguage = (a, b) => {
            let auxA = a.language === 'es' ? 1 : 0;
            let auxB = b.language === 'es' ? 1 : 0;
            return auxB - auxA;
        }

        const compareCustomFunction = (a, b) => {
            let auxA = a.customFunction ? 1 : 0;
            let auxB = b.customFunction ? 1 : 0;
            return auxB - auxA;
        }

        const compareNames = (a, b) => {
            return a.service.localeCompare(b.service);
        }

        processFetch().then(res => {
            setLinks(res
                .sort(compareNames)
                .sort(compareLanguage)
                .sort(compareCustomFunction)
            );
        }).catch(() => {
        }).finally(() => {
            setLinksLoading(false);
        });

    }, [episode, season, tmdbId, type]);

    const handleSelectLink = (link) => {
        setSelectedLink(link);
    }

    const handleClosePlayer = () => {
        setSelectedLink(null);
    }

    if (!selectedLink) {
        return (
            <div className="towersStreamViewer__torrents">
                <div className="towersStreamViewer__torrents__background">
                    {linksLoading &&
                        <div
                            className="d-flex flex-column justify-content-center align-items-center ps-4 pe-4 text-center text-light">
                            <div className="spinner-border text-light" role="status">
                            </div>
                            <div>
                                Estamos robando los links de los streams para este episodio
                            </div>
                            <div style={{
                                color: "rgba(255,255,255,0.7)",
                            }}>
                                Esto puede tardar unos segundos
                            </div>
                        </div>}
                    {!linksLoading && !links.length &&
                        <div className="text-center">
                            <div className="text-light" style={{fontSize: "1.3rem"}}>
                                No se encontraron streams para este contenido
                            </div>
                            <div style={{
                                color: "rgb(255,255,255, 0.7)",
                            }}>
                                Quizás el contenido no está disponible en este momento
                            </div>
                        </div>
                    }
                    {!linksLoading && !!links.length &&
                        <div className="towersStreamViewer__torrents__content">
                            <div className="towersStreamViewer__torrents__list">
                                <div className="text-light">
                                    Seleccione un enlace
                                </div>
                                <div className="towersStreamViewer__torrents__list__buttons">
                                    {links.map(link => {
                                        return <button
                                            className="btn btn-outline-light d-flex flex-row justify-content-center align-items-center"
                                            key={link.link}
                                            onClick={() => handleSelectLink(link)}>
                                            {link.service}&nbsp;·&nbsp;{link.language}<span
                                            className={"fi fi-" + link.language}></span>
                                            {link.customFunction &&
                                                <>
                                                    &nbsp;·&nbsp;<img src={logoIcon} height="20px" alt="logo"/>
                                                </>

                                            }
                                        </button>
                                    })}
                                </div>
                            </div>
                        </div>
                    }
                </div>
            </div>
        )
    }

    return (
        <>
            {!selectedLink.customFunction &&
                <div style={{width: "100%", aspectRatio: "16/9", position: "relative"}}>
                    <iframe style={{width: "100%", height: "100%", aspectRatio: "16/9"}}
                            allowFullScreen title={selectedLink.service}
                            src={selectedLink.link}></iframe>
                    <div className="towersStreamViewer__main__video-controls__top__options" style={{
                        position: "absolute",
                        top: "0",
                        right: "0",
                        zIndex: "1000"
                    }}>
                        <i className="fa-solid fa-square-xmark fa-2xl towersStreamViewer__main__video-controls__top__options__opt"
                           onClick={handleClosePlayer}></i>
                    </div>
                </div>}
            {
                selectedLink.customFunction &&
                <CustomFilePlayer imagePath={imagePath} title={item.title ?? item.name}
                                  onGoNextEpisode={onGoNextEpisode}
                                  squadFlixTvHook={squadFlixTvHook}
                                  customRuntime={item.runtime} item={item}
                                  onClosePlayer={handleClosePlayer}
                                  videoUrl={TorresstreamApi.get(selectedLink.customFunction)
                                      .getUrl({link: selectedLink.link, tmdbId, season, episode})}
                />
            }
        </>
    )
}

export default VeronlineStreamPlayer;
